import axios from 'axios';
import type { SupraSystemSubscriptionJsonType } from '@bb/domain/dist/types';

type FindSupraSubscriptionDTO = SupraSystemSubscriptionJsonType | undefined;

const findSupraSystemSubscription = async (params: {
  userId: string;
  orgId: string;
}) => {
  const { data } = await axios.get<FindSupraSubscriptionDTO>(
    `/supra_system/subscription/${params.userId}`,
    {
      params: {
        orgId: params.orgId,
      },
    },
  );

  if (data) return data;

  return undefined;
};

export default findSupraSystemSubscription;
